<template>
	<div>
		<div>
			<div ref="html" v-html="html" style="display: inline">
			</div>
			<a v-if="hasExtendedHtml && ! showExtendedHtml" @click="showExtendedHtml = true" class="ml-3">Läs mer</a>
		</div>
		<div v-show="hasExtendedHtml && showExtendedHtml" class="mt-5" style="color: #333">
			<div ref="extendedHtml" v-html="extendedHtml"></div>
			<div ref="afterExtendedHtml" v-html="afterExtendedHtml"></div>
			<a @click="showExtendedHtml = false">Visa mindre</a>
		</div>
	</div>
</template>

<script>
import { fixRelativeLinks, scrollTo } from 'utils';
import { debounce } from 'lodash';

export default {
	props: {
		html: {
			type: String,
			default: '',
		},
		extendedHtml: {
			type: String,
			default: '',
		},
		afterExtendedHtml: {
			type: String,
			default: '',
		},
		iframeReziser :{
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			showExtendedHtml: false,
			iframeHeight: 0,
			updateHeight: true,
			fixRelativeLinks,
			scrollTo,
		};
	},
	methods: {
		scrollToId(id) {
			id = '#' + id;
			if (this.$refs.html.querySelector(id)) {
				scrollTo(id, false);
			}
		},
		// Gets height data from iframe via campaign tool
		setIframeHeight (e) {
			if (e.data[0] != 'setHeight') return;
			let height = e.data[1];

			if (height === undefined) {
				/**  If height from event hasn't been fetched this sets a default
				*	height so the iframe may reload and set correct height
				*/
				this.updateHeight = false;
				this.iframeHeight = 2000;
			} else if (this.updateHeight && height) {
				// Sets updateHeight to false to avoid a loop where it deletes the height property
				this.updateHeight = false;
				this.iframeHeight = height;
			} else if (height !== this.iframeHeight) {
				this.iframeHeight = height;
			} else if (!this.updateHeight) {
				this.updateHeight = true;
			}
		},
	},
	computed: {
		hasExtendedHtml () {
			return this.extendedHtml && this.extendedHtml.trim().length > 0 || this.afterExtendedHtml && this.afterExtendedHtml.trim().length > 0;
		},
	},
	mounted () {
		// Checks if the iframereziser should be used for this specific component
		if (this.iframeReziser) {
			window.addEventListener('message', debounce(this.setIframeHeight, 100),false);
		}

		if (this.html !== '' || this.extendedHtml !== '') {
			const html = this.html;
			const extendedHtml = this.extendedHtml;
			const afterExtendedHtml = this.afterExtendedHtml;

			Vue.nextTick(() => {
				if (html !== '') {
					this.$emit('html-loaded');
					fixRelativeLinks(this.$refs.html);
				}
				if (extendedHtml !== '') {
					fixRelativeLinks(this.$refs.extendedHtml);
				}
				if (afterExtendedHtml !== '') {
					fixRelativeLinks(this.$refs.extendedHtml);
				}
			});
		}
	},
	beforeDestroy () {
		if (this.iframeReziser) {
			window.removeEventListener('message', debounce(this.setIframeHeight, 100));
		}
	},
	watch: {
		html () {
			this.showExtendedHtml = false;
			Vue.nextTick(() => {
				fixRelativeLinks(this.$refs.html);
				this.$emit('html-loaded');
			});
		},
		extendedHtml () {
			Vue.nextTick(() => {
				fixRelativeLinks(this.$refs.extendedHtml);
			});
		},
		// Checks if new iFrame height is set and then sends it to parent
		iframeHeight (to, frm) {
			if (to !== frm && typeof(to) === 'number') {
				this.$emit('iframeHeight', to);
				this.updateHeight = false;
			}
		},
	},
};
</script>